import { useContext, useCallback } from 'react';

import { Actions, Subjects } from 'types/ability';
import { AbilityContext } from 'components/Ability';

export const usePermissions = () => {
  const ability = useContext(AbilityContext);

  const definePermissions = useCallback(
    (action: Actions, subject: Subjects) => ability.can(action, subject),
    [ability]
  );

  return { can: definePermissions };
};
